import React, { useState, forwardRef, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Search = () => {
  const locations = [
    { id: 1, location: "Bommanahalli, Bengaluru" },
    { id: 2, location: "Kochi, Kerala" },
  ];

  const today = new Date();
  const [selectedLocation, setSelectedLocation] = useState(locations[0]?.location);
  const [checkInDate, setCheckInDate] = useState(new Date(today.setDate(today.getDate() + 1)));
  const [checkOutDate, setCheckOutDate] = useState(new Date(today.setDate(today.getDate() + 10)));

  const handleLocationChange = (e) => {
    setSelectedLocation(e.target.value);
  };


const CustomInput = forwardRef(({ value, onClick }, ref) => {
  return (
    <div className="relative w-full flex items-center" ref={ref}>
      <input
        type="text"
        readOnly
        value={value}
        className="w-full bg-transparent border-none outline-none text-[#1E1E1E] text-[12px] md:text-[14px] lg:text-[16px] font-normal leading-tight pr-2 lg:pr-1 cursor-default"
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="absolute -right-3 top-1/2 transform -translate-y-1/2 w-[12px] h-[12px] cursor-pointer"
        onClick={onClick} // 👈 this now triggers the datepicker
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </div>
  );
});








  return (
    <div className="bg-white shadow-md rounded-[1000px] flex flex-wrap sm:flex-nowrap items-center  w-[330px] md:w-[496px] lg:w-[616px] lg:h-[70px] h-[56px] lg:px-[36px] md:px-[32px] px-[23px] mx-auto relative">

      {/* Location */}
      <div className="flex flex-col justify-center lg:w-[196px] md:w-[173px] w-[78px] lg:h-[40px] md:h-[38px] h-[36px] items-start">
  <label className="font-outfit lg:text-[12px] md:text-[12px] text-[10px] font-light text-[#1E1E1E80] mb-[4px]">
    Location
  </label>

  {/* Wrapping in a label for accessibility and click behavior */}
  <label className="relative w-full cursor-pointer">
    <select
      value={selectedLocation}
      onChange={handleLocationChange}
      className="appearance-none bg-transparent border-none outline-none text-[#1E1E1E]  text-[12px] md:text-[14px] lg:text-[16px] w-full truncate cursor-pointer pr-6"
    >
      {locations.map((loc) => (
        <option key={loc.id} value={loc.location}>
          {loc.location}
        </option>
      ))}
    </select>

    {/* Visual dropdown arrow (SVG) - purely for looks */}
    <div className="pointer-events-none absolute right-1 top-1/2 transform -translate-y-1/2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-[12px] h-[12px] text-[#1E1E1E]"
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </div>
  </label>
</div>

   
<div className="w-[16.25px] md:w-[23.5px] lg:w-[40px]" />

  {/* Divider line */}
  <div className="bg-[#1E1E1E17] w-[0.5px] h-[32px] md:w-[0.7px] md:h-[32px] lg:w-[0.8px] lg:h-[43px]" />

  {/* Second half of the gap (40px in lg) */}
  <div className="w-[16.25px] md:w-[23.5px] lg:w-[40px]" />


      {/* Check-in */}
     <div className="flex flex-col  justify-center items-start lg:w-[58px] lg:h-[38px] w-[49px] h-[36px] md:w-[58px]  md:h-[38px]">
  <label className="text-[10px] md:text-[12px] font-light text-[#1E1E1E80] mb-[4px] font-outfit  ">
    Check-in
  </label>
  <div className="w-full">

    <DatePicker
  selected={checkInDate}
  onChange={(date) => setCheckInDate(date)}
  minDate={new Date()}
  dateFormat="MMM d"
  customInput={<CustomInput />}
/>

  </div>
</div>

<div className="w-[16.25px] md:w-[23.5px] lg:w-[40px]" />

  {/* Divider line */}
  <div className="bg-[#1E1E1E17] w-[0.5px] h-[32px] md:w-[0.7px] md:h-[32px] lg:w-[0.8px] lg:h-[43px]" />

  {/* Second half of the gap (40px in lg) */}
  <div className="w-[16.25px] md:w-[23.5px] lg:w-[40px]" />



      {/* Checkout */}
      <div className="flex flex-col justify-center items-start lg:w-[59px] lg:h-[38px]  w-[49px] h-[36px] md:w-[58px]  md:h-[38px]">
        <label className="text-[10px] md:text-[12px] font-light text-[#1E1E1E80] mb-[4px] font-outfit">Checkout</label>
        <DatePicker
  selected={checkOutDate}
  onChange={(date) => setCheckOutDate(date)}
  minDate={checkInDate}
  dateFormat="MMM d"
  customInput={<CustomInput />}
/>

        
      </div>

      {/* Search Button */}
      <button className="bg-black  w-[42px] h-[42px] md:w-[44px] md:h-[44px] lg:w-[46px] lg:h-[46px] text-white rounded-full  flex items-center justify-center absolute right-[10px] lg:right-[14.2px] border border-transparent hover:bg-white hover:text-black hover:border-black transition-all duration-300">
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.25571 2.03552C10.0989 2.03552 10.9338 2.2016 11.7128 2.52427C12.4918 2.84695 13.1996 3.31989 13.7959 3.91612C14.3921 4.51234 14.865 5.22016 15.1877 5.99916C15.5104 6.77816 15.6765 7.61309 15.6765 8.45627C15.6765 9.29946 15.5104 10.1344 15.1877 10.9134C14.865 11.6924 14.3921 12.4002 13.7959 12.9964C13.1996 13.5927 12.4918 14.0656 11.7128 14.3883C10.9338 14.7109 10.0989 14.877 9.25571 14.877C7.55282 14.877 5.91968 14.2006 4.71555 12.9964C3.51143 11.7923 2.83496 10.1592 2.83496 8.45627C2.83496 6.75338 3.51143 5.12024 4.71555 3.91612C5.91968 2.71199 7.55282 2.03552 9.25571 2.03552V2.03552Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7237 13.866C16.0043 13.8661 16.2735 13.9777 16.4719 14.1762C16.6702 14.3747 16.7816 14.6439 16.7815 14.9246C16.7814 15.2053 16.6699 15.4744 16.4713 15.6728C16.2728 15.8712 16.0036 15.9826 15.7229 15.9825C15.4422 15.9824 15.1731 15.8708 14.9747 15.6722C14.7763 15.4737 14.6649 15.2045 14.665 14.9238C14.6651 14.6432 14.7767 14.374 14.9753 14.1757C15.1738 13.9773 15.443 13.8659 15.7237 13.866V13.866Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default Search;
